import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-verify-header',
  templateUrl: './verify-header.component.html',
  styleUrls: ['./verify-header.component.scss'],
})
export class VerifyHeaderComponent  implements OnInit {
  @Input() exit!: () => void; // Função passada pelo pai como Input
  constructor(private translate: TranslateService) { }

  ngOnInit() {}
}
